import useSWR from "swr";
import { toast } from "react-toastify";
import useAuth from "../hooks/useAuth";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchData, PROXY } from "../lib/utils";
import { Button } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import { clearPendingCourseAction, readPendingCourseAction } from "../lib/pendingCourseAction";

const CourseEnroll = ({ courseId, onLoginRequired }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { isAuth, user, accessToken } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const fetcher = (url) => fetchData(url, accessToken);
    const { data, error } = useSWR(isAuth ? `${PROXY}/courses/enroll-course/${courseId}` : null, fetcher);

    // Check if the user is already enrolled in this course
    const isEnrolled = data?.enrolledUsers?.includes(user?._id || user?.id);

    useEffect(() => {
        if (!isAuth || !courseId) return;
        const pending = readPendingCourseAction();
        if (pending?.action === "start" && pending.courseId === String(courseId)) {
            clearPendingCourseAction();
        }
    }, [isAuth, courseId]);

    const courseEnrollHandler = async () => {
        if (!isAuth) {
            onLoginRequired?.("start");
            return;
        }

        try {
            setIsLoading(true);

            const res = await fetch(`${PROXY}/courses/enroll-course/${courseId}`, {
                method: "PATCH",
                headers: {
                    "Authorization": `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ courseId }),
            });

            const result = await res.json();

            if (res.ok) {
                toast.success(t("toast.course-enroll-success"));
                navigate(`/courses/${courseId}/current`);
            } else {
                toast.error(result.message || t("toast.course-enroll-failed"));
            }

        } catch (err) {
            toast.error(t("toast.course-enroll-error"));
        } finally {
            setIsLoading(false);
        }
    };

    if (error) return <div>{t("Error")}: {error.message}</div>;

    if (!isAuth) {
        return (
            <Button type="button" onClick={() => onLoginRequired?.("start")} className="text-lg px-3 py-2 bg-gray-800 text-white hover:shadow-lg hover:text-white font-bold rounded-md">
                {t("start-now")}
            </Button>
        );
    }

    return isEnrolled ? (
        <Button onClick={() => navigate(`/courses/${courseId}/current`)} className="text-xl px-3 py-2 bg-gray-800 text-white hover:shadow-lg hover:text-white font-bold rounded-md">
            {t("continue-course")}
        </Button>
    ) : (
        <Button onClick={courseEnrollHandler} className="text-xl px-3 py-2 bg-gray-800 text-white hover:shadow-lg hover:text-white font-bold rounded-md" disabled={isLoading}>
            {isLoading ? t("loading") : t("start-now")}
        </Button>
    );
};

export default CourseEnroll;
